module.exports = __webpack_public_path__ + "f3e64e3e6668ffbe23756f106bdaaac7.png";